import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markChatAsSeen } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

export const useMarkChatAsSeen = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (chatId: number) => markChatAsSeen(chatId),
    onSuccess: (_data, chatId) => {
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.Chats],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatMessages, chatId],
      });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatMessagesPaginated, chatId],
      });
    },
  });
};
